export default __webpack_public_path__ + "static/altHeaderImage-2b043b621b2d3bb4468f70c159481374.jpg";